import React from 'react';
import { useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import axios from 'axios';

function MedicationDelivery() {
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async (data) => {
    // Replace with actual API call
    // const response = await axios.post('api/medication-delivery', data);
    console.log('Delivery requested:', data);
    reset();
  };

  return (
    <motion.div initial={{ x: '-100vw' }} animate={{ x: 0 }} exit={{ x: '100vw' }}>
      <h2>Medication Delivery</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input {...register('address')} placeholder="Delivery Address" required />
        <input {...register('medication')} placeholder="Medication Name" required />
        <button type="submit">Request Delivery</button>
      </form>
    </motion.div>
  );
}

export default MedicationDelivery;
